/**
 * @desc: 曝光组件
 * @param {params} ExposureProps
 * @return {*}
 * @example 
 * <Exposure id={`#item-${item.recruitTaskId}`} onExpose={() => {
      recruitTaskCardExpo({
        page_name: pageName,
        recruit_project_id: item.recruitTaskId,
        recruit_status: INVITE_STATUS.get(item.inviteStatus) as string,
        apply_status: recruitTaskCardStatus,
        exposure_type: '展示曝光',
      });
    }}>
    <div id={`item-${item.recruitTaskId}`}></div>
  </Exposure>
 */

import { useMount, useUnmount } from 'ahooks';
import ExposureComponent from './exposure';

const exposure: ExposureComponent | null = new ExposureComponent();

type ExposureProps = {
  children: React.ReactNode;
  id: string; // 用来获取dom节点的值，如 .xxx. #xxx ，建议最好用pageName+唯一id组合。
  onExpose: () => void; // 用来发送埋点的函数。
};
function Exposure({ children, id, onExpose }: ExposureProps) {
  useMount(() => {
    if (!id) {
      throw Error(
        '请输入正确的id, 组件会通过该id获取对应监听对象。eg: ".xxx" || "#xxx"'
      );
    }
    exposure?.add(id, onExpose);
  });

  useUnmount(() => {
    exposure?.remove(id);
  });

  return <>{children}</>;
}

export default Exposure;
